import {createToaster, Portal, Spinner, Stack, Toast, Toaster as ChakraToaster} from '@chakra-ui/react';

/**
 * The app's single toast queue: `toaster.create({type, title, description, duration, closable})`,
 * `toaster.dismiss(id)`. Toasts last 5 s unless they say otherwise, like Chakra v2's did, and pause
 * while hovered.
 */
export const toaster = createToaster({placement: 'bottom', duration: 5000, offsets: '0.5rem'});

// Chakra v2's solid toasts: the status colour's 600 shade with white text.
const TYPE_PALETTE: Record<string, string> = {success: 'green', error: 'red', warning: 'orange', info: 'blue', loading: 'blue'};

/** Renders the toasts; mounted once, inside the Chakra provider. */
export function Toaster() {
    return <Portal>
        <ChakraToaster toaster={toaster}>
            {(toast) => (
                <Toast.Root
                    bg={`${TYPE_PALETTE[toast.type ?? 'info'] ?? 'blue'}.600`}
                    color="white"
                    width="auto"
                    minW="300px"
                    maxW="560px"
                    py="3"
                    ps="4"
                    pe={toast.closable ? '8' : '4'}
                    gap="0"
                    borderRadius="md"
                    boxShadow="lg"
                >
                    {toast.type === 'loading'
                        ? <Spinner size="sm" color="white" me="3" mt="0.5"/>
                        : <Toast.Indicator color="white" me="3" boxSize="5" h="6"/>}
                    <Stack gap="0" flex="1" maxW="100%">
                        {toast.title && <Toast.Title fontWeight="bold" textStyle="md" lineHeight="1.5rem" me="2">{toast.title}</Toast.Title>}
                        {toast.description &&
                            <Toast.Description display="block" textStyle="md" lineHeight="1.5rem" opacity="1">{toast.description}</Toast.Description>}
                    </Stack>
                    {toast.closable && <Toast.CloseTrigger color="white" top="1" insetEnd="1" css={{'& svg': {boxSize: '2.5'}}}/>}
                    {toast.action && <Toast.ActionTrigger onClick={toast.action.onClick}>
                        {toast.action.label}
                    </Toast.ActionTrigger>}
                </Toast.Root>
            )}
        </ChakraToaster>
    </Portal>;
}
